import { Injectable } from '@angular/core';
import { PurchasesByPeriodExportQuery, PurchasesByPeriodExportQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PurchasesByPeriodExportQuery)
@Wrapper(PurchasesByPeriodExportQueryHandlerBase)
export class PurchasesByPeriodExportQueryHandler {
    public constructor(
        http: Http
    ) { }
}
